import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { RemoteCheckEligibility } from "../../../data/usecases/remote-check-eligibility";
import { CheckEligibility } from "../../../domain/useages/check-eligiblity";
import { EligibilityResponse } from "../../../domain/models/eligibility-response";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface CheckEligibilityInterface {
  checkEligibility: Function;
  isEligibile: EligibilityResponse;
}

const initialStaes = {
  isEligibile: {} as EligibilityResponse,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useCheckEligibilitySlice: StateCreator<
  CheckEligibilityInterface
> = (set, get) => ({
  ...initialStaes,
  checkEligibility: async (id: string) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteCheckEligibility: CheckEligibility = new RemoteCheckEligibility(
      `${BASE_URL}${Endpoints.ELIGIBLITY}`,
      axiosHttpClient
    );

    let result = await remoteCheckEligibility.fetch(id);
    set(() => ({ isEligibile: result }));
  },
});
